// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wCkT","fullView":"styles_fullView__1miuX"};